import React, { FC, useEffect, useRef, useState } from 'react';
import { Icons } from '../../../../assets';
import { WorkExperience, WorkExperienceType } from '../../../../models/work-experience.model';
import { formatTimelineRange } from '../../../../utils';

const WorkExperienceItem: FC<{ item: WorkExperience; index: number; total: number }> = ({ item, index, total }) => {
  const descriptionRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const el = descriptionRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > el.clientHeight + 1);
    }
  }, [item.jobDescription]);

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-2">
        <img src={item.type === WorkExperienceType.EDUCATION ? Icons.EDUCATION : Icons.ORGANIZATION_ICON} className="h-5 w-5" alt="Icon" />
        <p className="font-semibold text-sm text-[#1A1A1A]">{item.jobTitle.name}</p>
      </div>
      <div className={`border-l border-[#2E7CF6] ml-2 pl-5 ${index + 1 < total ? 'pb-1' : ''}`}>
        <div className="font-normal my-2 text-sm text-[#1A1A1A]">
          <div ref={descriptionRef} className={`relative transition-all duration-200 ease-in-out ${isExpanded ? '' : 'line-clamp-2'}`}>
            {item.jobDescription}
            {!isExpanded && isOverflowing && (
              <span
                className="cursor-pointer text-blue-500"
                onClick={toggleDescription}
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0',
                  backgroundColor: 'white',
                  paddingLeft: '4px',
                }}>
                ...read more
              </span>
            )}
          </div>
        </div>
        <div className="flex items-center justify-between my-2">
          <div className="flex gap-2 items-center">
            <img src={Icons.CALENDAR} className="h-4 w-4" alt="Calendar" />
            <p className="font-normal text-xs text-[#1A1A1A]">{formatTimelineRange(item.employmentTenure)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkExperienceItem;
